import { View, Text, Image } from "@react-pdf/renderer";

import { Colors } from "../../../configs";
import { image1, image2 } from "../customer/imagesStrings";

const ReportHeader = () => (
  <View fixed>
    <Image
      src={image1}
      style={{ width: "100%", height: "auto", marginBottom: 10 }}
    />

    <View
      style={{
        marginBottom: 15,
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "flex-start",
        position: "absolute",
        left: "4rem",
        top: "3.8rem",
        gap: "15.1rem",
        marginTop: 18,
      }}
    >
      <View>
        <Text
          style={{
            fontSize: 11,
            fontWeight: "bold",
            color: Colors.REPORT_GREEN,
            marginBottom: 0.5,
          }}
        >
          Presto Valet
        </Text>
        <Text style={{ fontSize: 9, marginBottom: 1 }}>
          Certified Environmental Dry Cleaner
        </Text>
        <Text style={{ fontSize: 9, marginBottom: 1 }}>
          37, O'Conner St, Bloomberg, UK
        </Text>
        <Text style={{ fontSize: 9, marginBottom: 1 }}>
          TP: +360 245 675 467 | presto@prestovalet.net
        </Text>
        <Text style={{ fontSize: 9 }}>www.prestovalet.net</Text>
      </View>

      <Image src={image2} style={{ width: "100px", height: "50px" }} />
    </View>
    <View
      style={{
        borderBottomWidth: 1.5,
        borderBottomColor: Colors.REPORT_DARK_GREEN,
        marginVertical: 10,
        marginTop: 52,
        marginLeft: 48,
        marginRight: 30,
      }}
    />
  </View>
);

export default ReportHeader;
